import { useAuthStore } from '@/app/shared/stores/auth-store';
import { oktaAuth } from '@/app/shared/okta/auth';

export function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const authStore = useAuthStore();
  if (authStore.shouldUseOktaLogin) {
    const oktaToken = oktaAuth.getAccessToken();
    if (authStore.useApigeeFlow() && authStore.exchangeServiceToken) {
      headers['Authorization'] = 'Bearer ' + authStore.exchangeServiceToken;
      headers['ATB-Authorization'] = 'Bearer ' + oktaToken;
    } else if (oktaToken) {
      headers['Authorization'] = 'Bearer ' + oktaToken;
    }
  } else {
    if (authStore.formAuthJwtAccessToken) {
      headers['Authorization'] = 'Bearer ' + authStore.formAuthJwtAccessToken;
    }
  }
  return headers;
}

export function getCsrfToken(): string | null {
  const csrfRegex = /(?:^|;\s*)XSRF-TOKEN=([^;]*)/;
  const match = csrfRegex.exec(document.cookie);
  return match ? decodeURIComponent(match[1]) : null;
}
